import React, { Fragment, useState, useEffect } from 'react'
import LoginFirst from './components/LoginFirst'; 
import { Modal, ModalBody } from 'react-bootstrap';
import './../css/login.css';

export default function Login() {

    // eslint-disable-next-line
    const [loginStep, setLoginStep] = useState(1);
    // eslint-disable-next-line
    const [loginType, setLoginType] = useState(false);
    // eslint-disable-next-line
    const [loginPara, setLoginPara] = useState();

    // eslint-disable-next-line
    const [signupVerifyScreen, setSignupVerifyScreen] = useState(false);
    // eslint-disable-next-line
    const [signupVerifyPostData, setSignupVerifyPostData] = useState([]);


    useEffect(() => {
        document.body.classList.add('white_bg_fp_report');

        return function cleanup() {
            document.body.classList.remove('white_bg_fp_report');
        };

    }, []);


    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    // eslint-disable-next-line
    const [popupIcon, setPopupIcon] = useState('deleteicon');
        // eslint-disable-next-line
    const [popupTitle, setPopupTitle] = useState();
        // eslint-disable-next-line
    const [popupContent, setPopupContent] = useState();

    return (
        <Fragment>

            <div className="innercontainer mb40">
                <div className="mainwrapper">

                    <Modal show={show} onHide={handleClose} className='modal model-sm' dialogClassName='modal-container' keyboard centered>
                        <ModalBody>
                            <div className="p20">
                                <div className="text-center">
                                    <span className={popupIcon} />
                                </div>
                                <div className="text-center mt10 color1e3 fw600 font18">
                                    {popupTitle}
                                </div>
                                <div className="text-center mt10 color485 fw500 font14">
                                    {popupContent}
                                </div>
                                <div className="smallbtn mt20">
                                    <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>Cancel</button>
                                    <button type="button" className={popupIcon !== "successIcon" ? "btn btn-danger" : "btn btn-success"} onClick={handleClose}>Continue</button>
                                </div>
                            </div>
                        </ModalBody>
                    </Modal>

                    <div className="mt30 font20 fw600 color384 mob_pl20_pr20 d-none d-sm-block">Welcome to Finnovate,</div>
                    <div className="font13 color626 mob_pl20_pr20 d-none d-sm-block">Join us and set your path towards Financial Freedom</div>
                    <div className="row formWpr mt25"> 
                        <div className="col-lg-5 p0"> 
                            <LoginFirst  />
                        </div>
                        <div className="col-lg-7 qouteouter d-none d-md-block">
                            <video
                                autoPlay
                                muted
                                loop
                                style={{ height: "100%", width: "100%", objectFit: "cover" }} //object-fit:cover
                            >
                                <source src={"https://planapi.finnovate.in/login-2.mp4"} type="video/mp4" />
                            </video>
                        </div>
                    </div>

                </div>
            </div>


        </Fragment>
    )
}
